import React, { useEffect, useState } from 'react'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import ClearIcon from '@mui/icons-material/Clear'
import { IconButton } from '@mui/material'
const InstallPWA = ({ setShowDownloadBtn }) => {
  const [supportsPWA, setSupportsPWA] = useState(false)
  const [promptInstall, setPromptInstall] = useState(null)

  useEffect(() => {
    const handler = e => {
      e.preventDefault()
      console.log('we are being triggered :D')
      setSupportsPWA(true)
      setPromptInstall(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    return () => window.removeEventListener('transitionend', handler)
  }, [])

  const onClick = evt => {
    evt.preventDefault()
    if (!promptInstall) {
      // console.log('No')
      return
    }
    promptInstall.prompt()
  }
  if (!supportsPWA) {
    // console.log('No')
    return null
  }
  return (
    <div className='pwa-download-btn'>
      <div className='d-flex align-items-center'>
        <DownloadForOfflineIcon />
        <button
          className='link-button '
          id='setup_button'
          aria-label='Install app'
          // title='Install App'
          onClick={onClick}
        >
          {/* <Tooltip title='Add Food Dudes Delivery To Your Home Screen' arrow> */}
          &nbsp;Install Food Dudes Delivery App &nbsp;
          {/* </Tooltip> */}
        </button>
      </div>
      <IconButton onClick={() => setShowDownloadBtn(false)}>
        <ClearIcon sx={{ color: '#fff', fontSize: '18px' }} />
      </IconButton>
    </div>
  )
}

export default InstallPWA
